import { UserClaims } from '@okta/okta-auth-js';

import { User } from '../store/Users/UserModels';

const stringClaim = (claim: unknown): string => {
  if (typeof claim === 'string') return claim;
  if (typeof claim === 'number' || typeof claim === 'boolean') {
    return String(claim);
  }
  return '';
};

const stringListClaim = (claim: unknown): string[] => {
  // The UMA token hook emits roles and casbin_policies as arrays. Keep an
  // unexpected scalar as one fail-closed value: splitting on commas could
  // grant uncontracted roles and would corrupt comma-containing Casbin rules.
  const values = Array.isArray(claim) ? claim : [claim];
  return values.map(stringClaim).filter(value => value.length > 0);
};

const booleanClaim = (claim: unknown): boolean =>
  claim === true || claim === 'true';

/**
 * Create a `User` profile object from the claims returned in the access token
 * @param {UserClaims} claims - claims from the access token
 * @return {User} - a `User` for the currently authenticated user's profile
 */
export default function userProfileFromClaims(claims: UserClaims): User {
  return {
    email: claims.email ?? '',
    externalUserId: stringClaim(claims.uid),
    firstName: claims.given_name ?? '',
    isFederated: booleanClaim(claims.is_federated),
    lastName: claims.family_name ?? '',
    id: stringClaim(claims.user_id),
    primaryOrganizationCode: stringClaim(claims.organization_id),
    roles: stringListClaim(claims.roles),
    status: 'active',
    userName: claims.email ?? '',
    policies: stringListClaim(claims.casbin_policies),
  };
}
